// src/context/LanguageContext.js
import React, { createContext, useState, useEffect, useCallback } from 'react';


// 1. Create the LanguageContext
export const LanguageContext = createContext();


export const LanguageProvider = ({ children }) => {
  // 2. Load initial language from localStorage or default to 'ar'
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'ar';
  });

  // Separate CSS update function
  const updateStyles = useCallback((lang) => {
    const rootElement = document.documentElement;
    const isArabic = lang === 'ar';
    
    // Update HTML attributes
    rootElement.lang = lang;
    rootElement.dir = isArabic ? 'rtl' : 'ltr';
    rootElement.className = isArabic ? 'rtl' : 'ltr';
    
    // Preload new CSS files
    const preloadBootstrap = document.createElement('link');
    const preloadStyle = document.createElement('link');
    
    preloadBootstrap.rel = 'preload';
    preloadStyle.rel = 'preload';
    preloadBootstrap.as = 'style';
    preloadStyle.as = 'style';
    
    preloadBootstrap.href = `${process.env.PUBLIC_URL}/asset/${lang}/css/bootstrap.min.css`;
    preloadStyle.href = `${process.env.PUBLIC_URL}/asset/${lang}/css/style.css`;
    
    document.head.appendChild(preloadBootstrap);
    document.head.appendChild(preloadStyle);
    
    // Update existing CSS links
    const cssBootstrap = document.getElementById('cssCustomBootstrap');
    const cssStyle = document.getElementById('cssStyle');
    
    if (cssBootstrap && cssStyle) {
      cssBootstrap.href = preloadBootstrap.href;
      cssStyle.href = preloadStyle.href;
    }
    
    // Clean up preload links after a short delay
    setTimeout(() => {
      document.head.removeChild(preloadBootstrap);
      document.head.removeChild(preloadStyle);
    }, 1000);
  }, []);

  // 3. Save language to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('language', language);
    updateStyles(language);
  }, [language, updateStyles]);

  // Function to toggle between 'en' and 'ar'
  const toggleLanguage = () => {
    
    setLanguage((prevLang) => (prevLang === 'en' ? 'ar' : 'en'));
   
  };

  // Context value to provide
  const value = {
    language,
    toggleLanguage,
  };

  // 4. Return the context provider with the value
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};